import form from './consultation-form';
import hero from './hero';
import map from './map';
import nav from './nav';

export default {
  'consultation-form': form,
  'hero': hero,
  'map': map,
  'nav': nav
};